import { MenuItem, Select, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, RadioGroup } from "@mui/material";
import { titleCase } from "title-case";
import FormatBandwidth from "./FormatBandwidth";
import FormatNumber from "./FormatNumber";
import { Plan } from "../models";
import FormatPrice from "./FormatPrice";

type SelectorType = 'select' | 'table';
type ProxyType = 'HTTP' | 'SOCKS';

interface PlanSelectorProps extends React.ComponentProps<typeof Select> {
  plans: Plan[];
  labelId: string;
  inputRef: React.Ref<HTMLButtonElement>;
  proxyType?: ProxyType;
  type?: SelectorType;
}

const filterHttp = (plan: Plan) => (plan.httpProxy);
const filterSocks = (plan: Plan) => (plan.socksProxy);

export default (props: PlanSelectorProps) => {
  if (!props.proxyType) {
    return null;
  }

  const filterFn = props.proxyType === "HTTP" ? filterHttp : filterSocks;

  const filteredPlans = props.plans.filter(filterFn);

  const selectProps = { ...props };
  delete selectProps.proxyType;

  if (props.type === 'table') {
    return (
      <RadioGroup
        name="radio-buttons-group"
        onChange={props.onChange}
      >
        <TableContainer>
          <Table>
            <colgroup>
              <col style={{ width: '10%' }} />
              <col style={{ width: '30%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
            </colgroup>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Plan</TableCell>
                <TableCell>Monthly Requests</TableCell>
                <TableCell>Monthly Bandwidth</TableCell>
                <TableCell>Price</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>

              {filteredPlans.map((plan: Plan) => (

                <TableRow key={plan.name}>
                  <TableCell>
                    <Radio
                      ref={props.inputRef}
                      value={plan.name}
                      name={props.name}
                    />
                  </TableCell>
                  <TableCell>{titleCase(plan.name)}</TableCell>
                  <TableCell><FormatNumber value={plan.requestsLimit} /></TableCell>
                  <TableCell><FormatBandwidth bytes={plan.bandwidthLimit} /></TableCell>
                  <TableCell><FormatPrice priceAmount={plan.priceAmount} unit="month" /></TableCell>
                </TableRow>
              ))}
            </TableBody>

          </Table>
        </TableContainer>
      </RadioGroup >
    )
  } else {
    return (
      <Select defaultValue="" ref={props.inputRef} {...selectProps}>
        {filteredPlans.map((plan: Plan) => (
          <MenuItem key={plan.name} value={plan.name}>
            {titleCase(plan.name)} — <FormatPrice priceAmount={plan.priceAmount} unit="month" />
          </MenuItem>
        ))}
      </Select>
    );
  }
}
